<script setup lang="ts">
import InsightSource from '@/components/home/insights/insight-source.vue';
import { useInsightSources } from '@/components/home/insights/use-insight-sources';
import type { InsightHypothesisReason } from '@/types/insights';

interface PlainReason {
  text: string;
}
interface Props {
  label: string;
  reasons: PlainReason[] | InsightHypothesisReason[];
  hintId?: number;
}
const props = defineProps<Props>();

const { resolveSources } = useInsightSources();

const reasonTitle = (index: number) =>
  props.reasons.length > 1 ? `${props.label} ${index + 1}` : props.label;
</script>

<template>
  <VTooltip theme="popover" class="reason-tag-tooltip-container">
    <span
      class="c-outlineTag c-outlineTag--small c-outlineBtn--secondary c-title-medium--xs reason-tag"
    >
      {{ label }}
    </span>
    <template #popper>
      <div class="reason-tooltip">
        <div
          v-for="(reason, i) in reasons"
          :key="`${label}-${i}`"
          class="reason"
        >
          <div class="c-title-bold--m">{{ reasonTitle(i) }}</div>
          <div class="c-text-regular--m">
            {{ reason.text }}
          </div>
          <div class="sources">
            <template v-if="hintId !== undefined && 'id' in reason">
              <InsightSource
                v-for="source in resolveSources(reason.sources)"
                :key="source.position"
                :position="source.position"
                :adp-document="source.document"
                :insight-source-id="source.insightSourceId"
                :location="{
                  source_location: 'hypothesis_reason',
                  hintId,
                  hypothesisReasonId: reason.id,
                }"
                variant="gray"
              />
            </template>
          </div>
        </div>
      </div>
    </template>
  </VTooltip>
</template>

<style lang="scss" scoped>
.v-popper.reason-tag-tooltip-container {
  display: inline-flex;

  .reason-tag {
    cursor: default;
    display: inline-flex;
    color: $color-gray800;
  }
}

.reason-tooltip {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .reason {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .sources {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }
  }
}
</style>
